import {Controller} from "@hotwired/stimulus"

export default class extends Controller {

  static values = {
    name: {
      type: String,
      default: 'Downloading...'
    },

  }
  connect() {
    if (this.element.dataset.onConnect === "click") {
      this.element.click()
    } else if (this.element.dataset.onConnect === "window_active_click" && !document.hidden) {
      this.element.click()
    }
  }

  addSpinner() {
    this.element.innerHTML = '<span><i data-lucide="loader-circle" class="w-4 h-4 inline animate-spin"></i></span>&nbsp;' + this.nameValue
    if (window.lucide) window.lucide.createIcons()
    this.element.setAttribute('disabled', true)
  }

}
